import Table from '@/components/ezuro/workschedule/components/Table.vue';
import TableOverview from '@/components/ezuro/workschedule/components/TableOverview.vue';
import Actions from '@/components/ezuro/workschedule/components/Actions.vue';
import CreateSchedule from '@/components/ezuro/workschedule/components/CreateSchedule.vue';

export default {
  name: 'Department',
  props: {
    section: {
      type: String
    },
    schedule: {
      type: Object
    },
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    workScheduleType: {
      type: String
    }
  },
  components: {
    Table,
    TableOverview,
    Actions,
    CreateSchedule
  },
  data () {
    return {
      showAllRows: false
    }
  },
  computed: {
    filteredOut () {
      if (this.filterData.team_id && this.filterData.team_id.length) {
        for (const item of this.teams) {
          if (this.filterData.team_id.includes(item.id)) {
            return false;
          }
        }
      } else {
        if (this.filterData.shift_id && this.filterData.shift_id.length) {
          for (const shift of this.scheduleData.shifts) {
            if (this.filterData.shift_id.includes(shift.id) && shift.department_id == this.departmentId && shift.division_id == this.divisionId) {
              return false;
            }
          }
        } else {
          return false;
        }
      }

      return true;
    },
    records () {
      const records = [];

      if (this.schedule) {
        for (const item of this.scheduleData.records) {
          if (item.schedule_id === this.schedule.id) {
            if (!records[item.user_id]) {
              records[item.user_id] = [];
            }

            records[item.user_id].push(item);
          }
        }
      }

      return records;
    },
    teams () {
      const teams = {};
      const shiftsInRecords = [];
      const teamsInShifts = [];

      for (const key in this.records) {
        if (this.records[key].shift_id) {
          shiftsInRecords.push(this.records[key].shift_id);
        }
      }

      for (const shift of this.scheduleData.shifts) {
        if (shift.team_id && shiftsInRecords.includes(shift.id)) {
          teamsInShifts.push(shift.team_id);
        }
      }

      for (const team of this.scheduleData.teams) {
        if ((team.department_id == this.departmentId && team.division_id == this.divisionId) || teamsInShifts.includes(team.id)) {
          teams[team.id] = team;
        }
      }

      return Object.values(teams);
    }
  },
  methods: {
    updateScheduleData (data) {
      this.$emit('updateScheduleData', data);
    },
    toggleRow: function () {
      this.showAllRows = !this.showAllRows;
    },
    getCompanyName (id) {
      const companyId = this.$store.getters.getParamFromConfig('company_departments', this.departmentId, 'company_id');
      return id ? this.$store.getters.getParamFromConfig('user_companies', companyId, 'name', this.$i18n.locale) : null;
    },
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    filter: function () {
      this.$emit('filter');
    },
    editRecord: function (record) {
      this.$emit('editRecord', { record: record });
    },
    addRecord: function (data) {
      this.$emit('editRecord', data);
    },
    editDateFor (id) {
      this.$emit('editDateFor', id);
    },
    deleteSchedule (data) {
      this.$emit('deleteSchedule', { el: data.el, id: data.id });
    },
    copySchedule (id) {
      this.$emit('copySchedule', id);
    },
    downloadExcel (params) {
      this.$emit('downloadExcel', params);
    },
    editNotes (data) {
      this.$emit('editNotes', data);
    },
    setLoading: function (value) {
      this.$emit('loading', value);
    }
  }
}
